export const DEFAULT_ACTION = 'screen/NotificationDetailScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/NotificationDetailScreen/UPDATE_INPUT';

export const GET_NOTIFICATIONS = 'screen/NotificationDetailScreen/GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_LOADING = 'screen/NotificationDetailScreen/GET_NOTIFICATIONS_LOADING';
export const GET_NOTIFICATIONS_SUCCESS = 'screen/NotificationDetailScreen/GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAIL = 'screen/NotificationDetailScreen/GET_NOTIFICATIONS_FAIL';